import type { ReactNode } from 'react';
import { Aviso } from '@/components/ui/aviso';
import type { EstadoDelRecalculo, ReglasSinRecalcular } from '../types/pricing-rules.types';
import {
  avisoDeCambiosSinAplicar,
  avisoDeReglasCambiadas,
  detalleDeCambiosSinAplicar,
  esperanEnPalabras,
} from '../lib/recalculo';

/**
 * D11 (lote C1, spec 246 punto 8): cambiaste reglas y no recalculaste. Va en
 * Reglas (con «Aplicar las reglas y recalcular») y en Hoy, debajo de la tabla
 * de estrategias (con el enlace a Reglas). Sin reglas cambiadas, nada.
 *
 * Spec 294 (D-R4-4): con `cambios`, primero el aviso de los cambios sin aplicar
 * (todavía no rigen), con la acción; debajo, si hay, el de siempre (reglas que ya
 * rigen sin recalcular: un recálculo que falló, o lo de antes de R4), sin repetirla.
 */
export function AvisoReglasSinRecalcular({
  reglas,
  cambios,
  accion,
}: {
  reglas: ReglasSinRecalcular | null | undefined;
  cambios?: EstadoDelRecalculo['cambiosSinAplicar'];
  accion?: ReactNode;
}) {
  if (!reglas && !cambios) return null;
  return (
    <>
      {cambios && (
        <Aviso
          tono="alerta"
          titulo={avisoDeCambiosSinAplicar(cambios)}
          data-testid="cambios-sin-aplicar"
        >
          <div className="flex flex-wrap items-center justify-between gap-2">
            <span className="min-w-0 [overflow-wrap:anywhere]">
              {detalleDeCambiosSinAplicar(cambios)}
            </span>
            {accion}
          </div>
        </Aviso>
      )}
      {reglas && (
        <Aviso
          tono="alerta"
          titulo={
            <span className="[overflow-wrap:anywhere]">{avisoDeReglasCambiadas(reglas)}</span>
          }
          data-testid="reglas-sin-recalcular"
        >
          <div className="flex flex-wrap items-center justify-between gap-2">
            <span>{esperanEnPalabras(reglas)}</span>
            {!cambios && accion}
          </div>
        </Aviso>
      )}
    </>
  );
}
